import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Lease Details (/lease/:leaseID)
 */
export const leaseDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_LeaseDetails_Welcome_Title"),
    description: t("Tour_LeaseDetails_Welcome_Description"),
    target: () => queryTourTarget("lease-details-header"),
    placement: "bottom",
  },
  {
    title: t("Tour_LeaseDetails_Tabs_Title"),
    description: t("Tour_LeaseDetails_Tabs_Description"),
    target: () => queryTourTarget("lease-details-tabs"),
    placement: "bottom",
  },
  {
    title: t("Tour_LeaseDetails_Timeline_Title"),
    description: t("Tour_LeaseDetails_Timeline_Description"),
    target: () => queryTourTarget("lease-timeline"),
    placement: "top",
  },
  {
    title: t("Tour_LeaseDetails_Renew_Title"),
    description: t("Tour_LeaseDetails_Renew_Description"),
    target: () => queryTourTarget("lease-renew-button"),
    placement: "left",
  },
  {
    title: t("Tour_LeaseDetails_Normalize_Title"),
    description: t("Tour_LeaseDetails_Normalize_Description"),
    target: () => queryTourTarget("lease-normalize-rent"),
    placement: "left",
  },
];
